import { Switch } from '@mui/material'
import styled from '@emotion/styled'
import { Colors } from 'src/components/theme'

export const AntSwitch = (styled(Switch) as any)(({ theme, color, bgcolor }: any) => {
  return {
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff ',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: `${bgcolor ?? color ?? Colors.primaryBlue400}`,
        },
      },
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: '#fff',
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: 'rgba(0,0,0,.25)',
      boxSizing: 'border-box',
    },
    '& .Mui-disabled': {
      '.MuiFormControlLabel-label': {
        color: Colors.textDisabled,
      },
    },
  }
})
